import { pedestrianPopupTemplate } from '../config/appConfig'
import {
  AUTO_LAYER,
  AUTO_MDOT_ROUTE,
  AUTO_MDOT_TRUNKLINES,
  AUTO_TIER1,
  AUTO_TIER2,
  BIKE_DEMAND_AREA,
  BIKE_EX_ON_ROAD,
  BIKE_EX_PATH,
  BIKE_PL_ON_ROAD,
  BIKE_PL_PATH,
  FREIGHT_ACT_CENTER,
  FREIGHT_FAF4,
  FREIGHT_TRUCK_RT,
  PED_DEMAND_AREA,
  PED_LANDUSECONTEXT,
  PED_TRANSIT_TIER,
  TRANSIT_BWAT,
  TRANSIT_DDOT,
  TRANSIT_FAST,
  TRANSIT_LET,
  TRANSIT_PLANNED,
  TRANSIT_QLINE,
  TRANSIT_REF_LAYER_1,
  TRANSIT_REF_LAYER_2,
  TRANSIT_REF_LAYER_3,
  TRANSIT_RIDE,
  TRANSIT_SMART,
  TRANSIT_UM
} from '../constants/layerFieldNames'

export function assignPedestrianPopup(sublayer) {
  const pedestrianArcadeExpressionInfos = [
    {
      name: 'ped-tier-arcade',
      title: 'Tier',
      expression: "if(true){return '1'}"
    },
    {
      name: 'ped-tier-landuse-arcade',
      title: 'Facility/Source',
      expression: "if(true){return 'Land Use Context'}"
    },
    {
      name: 'ped-tier-transit-arcade',
      title: 'Facility/Source',
      expression: "if(true){return 'Transit Tier 1'}"
    },
    {
      name: 'ped-tier-demand-arcade',
      title: 'Facility/Source',
      expression: "if(true){return 'Bike & Pedestrian Demand Area'}"
    }
  ]
  sublayer.sublayers.items.forEach((layer) => {
    if (layer.sublayers) {
      layer.sublayers.items.forEach((pedestrianTier1Sublayer) => {
        pedestrianTier1Sublayer.popupEnabled = true
        if (pedestrianTier1Sublayer.title === PED_LANDUSECONTEXT) {
          pedestrianTier1Sublayer.popupEnabled = true
          pedestrianTier1Sublayer.popupTemplate = {
            title: 'Pedestrian',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/ped-tier-arcade'
                  },
                  {
                    fieldName: 'expression/ped-tier-landuse-arcade'
                  }
                ]
              }
            ],
            expressionInfos: pedestrianArcadeExpressionInfos
          }
        } else if (pedestrianTier1Sublayer.title === PED_TRANSIT_TIER) {
          pedestrianTier1Sublayer.popupEnabled = true
          pedestrianTier1Sublayer.popupTemplate = {
            title: 'Pedestrian',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/ped-tier-arcade'
                  },
                  {
                    fieldName: 'expression/ped-tier-transit-arcade'
                  }
                ]
              }
            ],
            expressionInfos: pedestrianArcadeExpressionInfos
          }
        } else if (pedestrianTier1Sublayer.title === PED_DEMAND_AREA) {
          pedestrianTier1Sublayer.popupEnabled = true
          pedestrianTier1Sublayer.popupTemplate = {
            title: 'Pedestrian',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/ped-tier-arcade'
                  },
                  {
                    fieldName: 'expression/ped-tier-demand-arcade'
                  }
                ]
              }
            ],
            expressionInfos: pedestrianArcadeExpressionInfos
          }
        }
      })
    } else {
      layer.popupEnabled = true
      layer.popupTemplate = pedestrianPopupTemplate
    }
  })
}

export function assignBikePopup(sublayer) {
  const bikeArcadeExpressionInfos = [
    {
      name: 'bike-tier-arcade',
      title: 'Tier',
      expression: 'if(true){return $feature.TAG}'
    },
    {
      name: 'bike-tier-demand-arcade',
      title: 'Tier',
      expression: 'if(true){return 3}'
    },
    {
      name: 'bike-pl-path',
      title: 'Facility/Source',
      expression: "if(true){return 'Planned, Path'}"
    },
    {
      name: 'bike-ex-path',
      title: 'Facility/Source',
      expression: "if(true){return 'Existing, Path'}"
    },
    {
      name: 'bike-pl-on-road',
      title: 'Facility/Source',
      expression: "if(true){return 'Planned, On Road'}"
    },
    {
      name: 'bike-ex-on-road',
      title: 'Facility/Source',
      expression: "if(true){return 'Existing, On Road'}"
    },
    {
      name: 'bike-demand-area',
      title: 'Facility/Source',
      expression: "if(true){return 'Bike & Pedestrian Demand Area'}"
    }
  ]
  sublayer.sublayers.items.forEach((layer) => {
    if (layer.sublayers) {
      layer.sublayers.items.forEach((bikeSublayer) => {
        bikeSublayer.popupEnabled = true
        if (bikeSublayer.title === BIKE_PL_ON_ROAD) {
          bikeSublayer.popupEnabled = true
          bikeSublayer.popupTemplate = {
            title: 'Bike',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/bike-tier-arcade'
                  },
                  {
                    fieldName: 'expression/bike-pl-on-road'
                  }
                ]
              }
            ],
            expressionInfos: bikeArcadeExpressionInfos
          }
        } else if (bikeSublayer.title === BIKE_EX_ON_ROAD) {
          bikeSublayer.popupEnabled = true
          bikeSublayer.popupTemplate = {
            title: 'Bike',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/bike-tier-arcade'
                  },
                  {
                    fieldName: 'expression/bike-ex-on-road'
                  }
                ]
              }
            ],
            expressionInfos: bikeArcadeExpressionInfos
          }
        } else if (bikeSublayer.title === BIKE_PL_PATH) {
          bikeSublayer.popupEnabled = true
          bikeSublayer.popupTemplate = {
            title: 'Bike',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/bike-tier-arcade'
                  },
                  {
                    fieldName: 'expression/bike-pl-path'
                  }
                ]
              }
            ],
            expressionInfos: bikeArcadeExpressionInfos
          }
        } else if (bikeSublayer.title === BIKE_EX_PATH) {
          bikeSublayer.popupEnabled = true
          bikeSublayer.popupTemplate = {
            title: 'Bike',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/bike-tier-arcade'
                  },
                  {
                    fieldName: 'expression/bike-ex-path'
                  }
                ]
              }
            ],
            expressionInfos: bikeArcadeExpressionInfos
          }
        } else if (bikeSublayer.title === BIKE_DEMAND_AREA) {
          bikeSublayer.popupEnabled = true
          bikeSublayer.popupTemplate = {
            title: 'Bike',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/bike-tier-demand-arcade'
                  },
                  {
                    fieldName: 'expression/bike-demand-area'
                  }
                ]
              }
            ],
            expressionInfos: bikeArcadeExpressionInfos
          }
        }
      })
    }
  })
}

export function assignFreightPopup(sublayer) {
  const freightArcadeExpressionInfos = [
    {
      name: 'freight-tier-arcade',
      title: 'Tier',
      expression: 'if(true){return $feature.TAG}'
    },
    {
      name: 'freight-faf4',
      title: 'Facility/Source',
      expression: "if(true){return 'FAF4 Network'}"
    },
    {
      name: 'freight-truck-route',
      title: 'Facility/Source',
      expression: "if(true){return 'SEMCOG Truck Route'}"
    }
  ]
  sublayer.sublayers.items.forEach((layer) => {
    if (layer.sublayers) {
      layer.sublayers.items.forEach((freightSublayer) => {
        if (freightSublayer.title === FREIGHT_FAF4) {
          freightSublayer.popupEnabled = true
          freightSublayer.popupTemplate = {
            title: 'Freight',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/freight-tier-arcade'
                  },
                  {
                    fieldName: 'expression/freight-faf4'
                  }
                ]
              }
            ],
            expressionInfos: freightArcadeExpressionInfos
          }
        } else if (freightSublayer.title === FREIGHT_TRUCK_RT) {
          freightSublayer.popupEnabled = true
          freightSublayer.popupTemplate = {
            title: 'Freight',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/freight-tier-arcade'
                  },
                  {
                    fieldName: 'expression/freight-truck-route'
                  }
                ]
              }
            ],
            expressionInfos: freightArcadeExpressionInfos
          }
        } else if (freightSublayer.title === FREIGHT_ACT_CENTER) {
          freightSublayer.visible = false
        }
      })
    }
  })
}

export function assignAutoPopup(sublayer) {
  const autoArcadeExpressionInfos = [
    {
      name: 'auto-tier1-arcade',
      title: 'Tier',
      expression: 'if(true){return 1}'
    },
    {
      name: 'auto-tier2-arcade',
      title: 'Tier',
      expression: 'if(true){return 2}'
    },
    {
      name: 'auto-tier3-arcade',
      title: 'Tier',
      expression: 'if(true){return 3}'
    },
    {
      name: 'auto-tier-facitlity',
      title: 'Facility/Source',
      expression: "if(true){return 'National Functional Classification'}"
    },
    {
      name: 'auto-mdot-facitlity',
      title: 'Facility/Source',
      expression: "if(true){return 'MDOT Route'}"
    },
    {
      name: 'auto-facitlity',
      title: 'Facility/Source',
      expression: "if(true){return 'Auto'}"
    }
  ]
  sublayer.sublayers.items.forEach((layer) => {
    if (layer.sublayers) {
      layer.sublayers.items.forEach((autoSublayer) => {
        if (autoSublayer.title === AUTO_MDOT_ROUTE) {
          autoSublayer.popupEnabled = true
          autoSublayer.popupTemplate = {
            title: 'Auto',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/auto-tier3-arcade'
                  },
                  {
                    fieldName: 'expression/auto-mdot-facitlity'
                  }
                ]
              }
            ],
            expressionInfos: autoArcadeExpressionInfos
          }
        } else if (autoSublayer.title === AUTO_LAYER) {
          autoSublayer.popupEnabled = true
          autoSublayer.popupTemplate = {
            title: 'Auto',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/auto-tier3-arcade'
                  },
                  {
                    fieldName: 'expression/auto-facitlity'
                  }
                ]
              }
            ],
            expressionInfos: autoArcadeExpressionInfos
          }
        } else if (autoSublayer.title === AUTO_MDOT_TRUNKLINES) {
          autoSublayer.visible = false
        }
      })
    } else {
      if (layer.title === AUTO_TIER1) {
        layer.popupEnabled = true
        layer.popupTemplate = {
          title: 'Auto',
          content: [
            {
              type: 'fields',
              fieldInfos: [
                {
                  fieldName: 'expression/auto-tier1-arcade'
                },
                {
                  fieldName: 'expression/auto-tier-facitlity'
                }
              ]
            }
          ],
          expressionInfos: autoArcadeExpressionInfos
        }
      } else if (layer.title === AUTO_TIER2) {
        layer.popupEnabled = true
        layer.popupTemplate = {
          title: 'Auto',
          content: [
            {
              type: 'fields',
              fieldInfos: [
                {
                  fieldName: 'expression/auto-tier2-arcade'
                },
                {
                  fieldName: 'expression/auto-tier-facitlity'
                }
              ]
            }
          ],
          expressionInfos: autoArcadeExpressionInfos
        }
      }
    }
  })
}

export function assignTransitPopup(sublayer) {
  const transitArcadeExpressionInfos = [
    {
      name: 'transit-tier1-arcade',
      title: 'Tier',
      expression: 'if(true){return 1}'
    },
    {
      name: 'transit-tier2-arcade',
      title: 'Tier',
      expression: 'if(true){return 2}'
    },
    {
      name: 'transit-tier3-arcade',
      title: 'Tier',
      expression: 'if(true){return 3}'
    },
    {
      name: 'transit-UM',
      title: 'Facility/Source',
      expression: "if(true){return 'UM'}"
    },
    {
      name: 'transit-Qline',
      title: 'Facility/Source',
      expression: "if(true){return 'QLine'}"
    },
    {
      name: 'transit-FAST',
      title: 'Facility/Source',
      expression: "if(true){return 'FAST'}"
    },
    {
      name: 'transit-TheRide',
      title: 'Facility/Source',
      expression: "if(true){return 'TheRide'}"
    },
    {
      name: 'transit-Planned',
      title: 'Facility/Source',
      expression: "if(true){return 'Planned'}"
    },
    {
      name: 'transit-DDOT',
      title: 'Facility/Source',
      expression: "if(true){return 'DDOT'}"
    },
    {
      name: 'transit-UM',
      title: 'Facility/Source',
      expression: "if(true){return 'UM'}"
    },
    {
      name: 'transit-LET',
      title: 'Facility/Source',
      expression: "if(true){return 'LET'}"
    },
    {
      name: 'transit-BWAT',
      title: 'Facility/Source',
      expression: "if(true){return 'BWAT'}"
    },
    {
      name: 'transit-smart',
      title: 'Facility/Source',
      expression: "if(true){return 'SMART'}"
    }
  ]
  sublayer.sublayers.items.forEach((layer) => {
    if (layer.sublayers) {
      layer.sublayers.items.forEach((transitSublayer) => {
        if (transitSublayer.title === TRANSIT_DDOT) {
          transitSublayer.popupEnabled = true
          transitSublayer.popupTemplate = {
            title: 'Transit',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName:
                      transitSublayer.id === 29
                        ? 'expression/transit-tier1-arcade'
                        : 'expression/transit-tier2-arcade'
                  },
                  {
                    fieldName: 'expression/transit-DDOT'
                  }
                ]
              }
            ],
            expressionInfos: transitArcadeExpressionInfos
          }
        } else if (transitSublayer.title === TRANSIT_UM) {
          transitSublayer.popupEnabled = true
          transitSublayer.popupTemplate = {
            title: 'Transit',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/transit-tier1-arcade'
                  },
                  {
                    fieldName: 'expression/transit-UM'
                  }
                ]
              }
            ],
            expressionInfos: transitArcadeExpressionInfos
          }
        } else if (transitSublayer.title === TRANSIT_QLINE) {
          transitSublayer.popupEnabled = true
          transitSublayer.popupTemplate = {
            title: 'Transit',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/transit-tier1-arcade'
                  },
                  {
                    fieldName: 'expression/transit-Qline'
                  }
                ]
              }
            ],
            expressionInfos: transitArcadeExpressionInfos
          }
        } else if (transitSublayer.title === TRANSIT_FAST) {
          transitSublayer.popupEnabled = true
          transitSublayer.popupTemplate = {
            title: 'Transit',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/transit-tier1-arcade'
                  },
                  {
                    fieldName: 'expression/transit-FAST'
                  }
                ]
              }
            ],
            expressionInfos: transitArcadeExpressionInfos
          }
        } else if (transitSublayer.title === TRANSIT_RIDE) {
          transitSublayer.popupEnabled = true
          transitSublayer.popupTemplate = {
            title: 'Transit',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/transit-tier-arcade'
                  },
                  {
                    fieldName: 'expression/transit-TheRide'
                  }
                ]
              }
            ],
            expressionInfos: transitArcadeExpressionInfos
          }
        } else if (transitSublayer.title === TRANSIT_PLANNED) {
          transitSublayer.popupEnabled = true
          transitSublayer.popupTemplate = {
            title: 'Transit',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName:
                      transitSublayer.id === 34
                        ? 'expression/transit-tier1-arcade'
                        : 'expression/transit-tier2-arcade'
                  },
                  {
                    fieldName: 'expression/transit-Planned'
                  }
                ]
              }
            ],
            expressionInfos: transitArcadeExpressionInfos
          }
        } else if (transitSublayer.title === TRANSIT_LET) {
          transitSublayer.popupEnabled = true
          transitSublayer.popupTemplate = {
            title: 'Transit',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/transit-tier2-arcade'
                  },
                  {
                    fieldName: 'expression/transit-LET'
                  }
                ]
              }
            ],
            expressionInfos: transitArcadeExpressionInfos
          }
        } else if (transitSublayer.title === TRANSIT_BWAT) {
          transitSublayer.popupEnabled = true
          transitSublayer.popupTemplate = {
            title: 'Transit',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/transit-tier3-arcade'
                  },
                  {
                    fieldName: 'expression/transit-BWAT'
                  }
                ]
              }
            ],
            expressionInfos: transitArcadeExpressionInfos
          }
        } else if (transitSublayer.title === TRANSIT_SMART) {
          transitSublayer.popupEnabled = true
          transitSublayer.popupTemplate = {
            title: 'Transit',
            content: [
              {
                type: 'fields',
                fieldInfos: [
                  {
                    fieldName: 'expression/transit-tier3-arcade'
                  },
                  {
                    fieldName: 'expression/transit-smart'
                  }
                ]
              }
            ],
            expressionInfos: transitArcadeExpressionInfos
          }
        } else if (
          transitSublayer.title === TRANSIT_REF_LAYER_1 ||
          transitSublayer.title === TRANSIT_REF_LAYER_2 ||
          transitSublayer.title === TRANSIT_REF_LAYER_3
        ) {
          transitSublayer.visible = false
        }
      })
    }
  })
}
